import Param from '../../param';

const param = new Param();

export default class accordionManager {
    constructor(param){

        //pc sp
        this.accTrigger = document.querySelectorAll('.js__acc-trigger');
        this.accContent = document.querySelectorAll('.js__acc-content');

        //sp only
        this.accTriggerSP = document.querySelectorAll('.js__acc-trigger-sp');
        this.accContentSP = document.querySelectorAll('.js__acc-content-sp');

        /* ステータス */
        this.status = {
            device : ( window.innerWidth>param.breakpoint )?"pc":"sp"
        }

        this.param = param;

        this.init();

    }
    init(){

        let _length = this.accTrigger.length;

        for(let i = 0 ; i < _length ; i++){
            let _index = i;
            this.accTrigger[i].onclick = () => {
                if(this.accTrigger[_index].classList.contains('is-open') == true){
                    this.motion('out',_index,'all');
                }else{
                    this.motion('on',_index,'all');
                }
                return false;
            };
        }

        let _lengthSP = this.accTriggerSP.length;

        for(let i = 0 ; i < _lengthSP ; i++){
            let _index = i;
            this.accTriggerSP[i].onclick = () => {
                if(this.status.device === 'pc') return;
                if(this.accTriggerSP[_index].classList.contains('is-open') == true){
                    this.motion('out',_index,'sp');
                }else{
                    this.motion('on',_index,'sp');
                }
                return false;
            };
        }

    }

    motion(mode,index,type){

        if(type === 'sp'){ //sp only
            switch(mode){
                case "on":
                    TweenMax.set(this.accContentSP[index], { display: 'none', opacity:0 });
                    this.accTriggerSP[index].classList.add('is-open');
                    TweenMax.to(this.accContentSP[index],0.3, {
                        display: 'block',
                        opacity:1,
                        ease: Power1.easeIn,
                    });
                    break;
                case "out":
                    this.accTriggerSP[index].classList.remove('is-open');
                    TweenMax.to(this.accContentSP[index],0.3, {
                        display: 'none',
                        opacity:0,
                        ease: Power1.easeOut,
                    });
                    break;
            }
        }else{ // all
            switch(mode){
                case "on":
                    TweenMax.set(this.accContent[index], { display: 'none', opacity:0 });
                    this.accTrigger[index].classList.add('is-open');
                    TweenMax.to(this.accContent[index],0.3, {
                        display: 'block',
                        opacity:1,
                        ease: Power1.easeIn,
                        onComplete:function(){
                            if(param.browserType === 'IE'){
                                let event = document.createEvent('Event');
                                event.initEvent('resize', true, true);
                                window.dispatchEvent(event);
                            }else {
                                window.dispatchEvent(new Event('resize')); //スムーススクロールのl-rootの高さ再取得のためリサイズイベントを走らせる
                            }
                        }
                    });
                    break;
                case "out":
                    this.accTrigger[index].classList.remove('is-open');
                    TweenMax.to(this.accContent[index],0.3, {
                        display: 'none',
                        opacity:0,
                        ease: Power1.easeOut,
                        onComplete:function(){
                            if(param.browserType === 'IE'){
                                let event = document.createEvent('Event');
                                event.initEvent('resize', true, true);
                                window.dispatchEvent(event);
                            }else {
                                window.dispatchEvent(new Event('resize')); //スムーススクロールのl-rootの高さ再取得のためリサイズイベントを走らせる
                            }
                        }
                    });
                    break;
            }
        }
    }

    resize(_w,_h){
        if(_w>this.param.breakpoint){
            this.status.device = "pc";
        }else{
            this.status.device = "sp";
        }
    }


}